import React, { useState, useEffect, useRef, useCallback } from "react";
import {Modal, Paper, Typography, Grid, TextField, Button, Stack, CircularProgress} from "@mui/material";
import {SPORTSSHOPVERIFYOTP, SPORTSSHOPOTP, REGISTERSPORTSSHOP} from "../../api/apiConfig";
import LoopIcon from '@mui/icons-material/Loop';
import { useMediaQuery } from "react-responsive";
import ImageUploading from "react-images-uploading";
import { DndProvider } from "react-dnd";
import { BiLoaderCircle } from "react-icons/bi";
import { HTML5Backend } from "react-dnd-html5-backend";
import { Container } from "../../components/DragDropCard/DragDropCard";
import ImageResizer from "../../components/organisms/ImageResizer/ImageResizer";
import {FaPercent} from "react-icons/fa"
import { useForm } from "react-hook-form";
import { toast, Toaster } from 'react-hot-toast';

import axios from "axios";

import {
    Title,
    SecondaryButton,
    Spinner,
    AnchorLink,
  } from "../../components/atoms";

const ResendOtpComponent = ({email, resendClicked}) =>{
    const [isLoading, setIsLoading] = useState(false);
    const [countdown, setCountdown] = useState(60); 

    useEffect(() => {
        
        
        let timer;
        if (countdown > 0) {
          timer = setTimeout(() => setCountdown(countdown - 1), 1000);
        }
        return () => clearTimeout(timer);
      }, [countdown]);

      const handleResendOtp = async () => {
        setIsLoading(true);
    
        try {
            const response = await axios({
                url: SPORTSSHOPOTP, 
                method: "POST",
                responseType: "json",
                data: {
                    Email: email
                }
            });
        

            if(response.status === 200) {
                setCountdown(60);
                resendClicked();
                    
                }
            
        } catch (e) {
            setIsLoading(false);
            setCountdown(60);
            console.error(e);
        }
        
            
           setIsLoading(false);
            
        
    }
      return (
        <div>
            {countdown > 0 ? (
          <p className="countdown-text">Resend otp in {countdown} seconds</p>
        ) : (
          <Button
            variant="contained"
            startIcon={isLoading ? <Spinner size={20} color="white" loading={isLoading} /> : <LoopIcon />}
            onClick={handleResendOtp}
          >
            Resend Otp
          </Button>
        )}
        </div>
      )
}
const VerifyEmailScreen =({updateEmailVerification})=>{

  const [otpScreen, setOtpScreen] = useState(false);
  const [email, setEmail] = useState('');
  const [emailError, setEmailError] = useState(false);
  const numberOfDigits = 6;
  const [otp, setOtp] = useState(new Array(numberOfDigits).fill(""));
  const [otpError, setOtpError] = useState(null);
  const [currentFocusIndex, setCurrentFocusIndex] = useState(null);
  const otpBoxReference = useRef([]);
  const [isLoading, setIsLoading] = useState(false);
  const [isWrongOtp, setIsWrongOtp] = useState(false);
  const isTabletOrMobile = useMediaQuery({ query: '(max-width: 900px)' });
  


  //updateEmailVerification();
 

//   useEffect(() => {
//     if (otpScreen) {
//         setCountdown(60);
//     }
//   }, [otpScreen]);

  useEffect(() => {
    if (currentFocusIndex !== null && otpBoxReference.current[currentFocusIndex]) {
      otpBoxReference.current[currentFocusIndex].focus();
    }
  }, [currentFocusIndex]);

  const handleEmailChange = (event) => {
    setEmail(event.target.value);

    if(!checkValidEmail(event.target.value)) {setEmailError(true);
    }else{
        setEmailError(false);
    }

  };
  const checkValidEmail = (email) =>{
    const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
   
    return emailPattern.test(email);
  }

const handleChange = async (value, index) => {
    
    if (isNaN(value)) return;
    
  

    let newArr = [...otp];
    newArr[index] = value;
    setOtp(newArr);
    
    if(value && index < numberOfDigits-1){
       
       if(value != "") setCurrentFocusIndex(index + 1);
    }
    if(value && index === numberOfDigits -1)
        {
            
            if (isNaN(otp.join(''))) return;
            
          
                await handleVerifyOtp(newArr);
            
        }
  }
 const handleVerifyOtp = async (Otp = otp)=>{
    setIsLoading(true);
    
    try {
        const response = await axios({
            url: SPORTSSHOPVERIFYOTP, 
            method: "POST",
            responseType: "json",
            data: {
                Email: email,
                Otp: String(Otp.join(''))
            }
        });
    
        if(response.status === 200) {
           
           if(response.data.success)
            {
                updateEmailVerification(email);
                toast.success("Email verified successfuly");
            }
            else{
                setIsWrongOtp(true);
                toast.error("Invalid otp");
            }
            
                
            }
        
    } catch (e) {
        setIsLoading(false);
        toast.error("something went wwrong");
        console.error(e);
    }
    
        
       setIsLoading(false);
        
 }
  const handleBackspaceAndEnter = async (e, index) =>{
    if(e.key === "Backspace" && !e.target.value && index > 0){
       
        setCurrentFocusIndex(index - 1);
    }
   
    if(e.key === "Enter" ){
       
        if(index < numberOfDigits-1){
            setCurrentFocusIndex(index + 1);
        }
        if (/^\d{6}$/.test(otp.join(''))) {
           
           
                await handleVerifyOtp();
           
        }
    }
  }


 
  const handleVerifyEmailClick = async () => {
   if(emailError || isLoading) return;
   if(email === "" || email === undefined || email === null) return;

   setIsLoading(true);
   try {
    const response = await axios({
        url: SPORTSSHOPOTP, 
        method: "POST",
        responseType: "json",
        data: {
            Email: email
        }
    });

    if(response.status === 200) {
            setOtpScreen(true);
            
        }
    
} catch (e) {
    setIsLoading(false);
    console.error(e);
}

    
   setIsLoading(false);
    
    
  };
const handleResendOtp = ()=>{
    setIsWrongOtp(false);
}
const handleEnterOnPaper = async (e)=>{
    if(e.key != "Enter" ) return;

    if (/^\d{6}$/.test(otp.join(''))) {
        
      
    
         await handleVerifyOtp(); 
    }
}
const handlePaste = async (e) => {
    const pasteData = e.clipboardData.getData("text");
    if (/^\d{6}$/.test(pasteData)) {
     
      const newOtp = pasteData.split("");
      setOtp(newOtp);

      
      otpBoxReference.current[5].focus();
     
        await handleVerifyOtp(newOtp);
      
      

    }
   
    e.preventDefault(); 
  };
  const OtpScreen = () => (
    
    <div className="center-container">
        <Paper className="center-paper" style={{width: isTabletOrMobile ? '100%' : '40%'}} onKeyDown={handleEnterOnPaper}>
       
        <div style={{ padding: '20px' }}>
          {isWrongOtp ? (<Title text={`${"Wrong otp entered for "}${email}`} className="boxContentErr" />) : (<Title text={`${"Enter otp sent to "}${email}`} className="boxContent" />)}
           
        </div>
     <div >
      
      {isLoading ?(
       <div className="spinner-container" style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100px' }}>
       <CircularProgress size={40} color="inherit" />
     </div>) : 
      (<div className='center otp-container'>
        {otp.map((digit, index)=>(
        <input key={index} value={digit} maxLength={1}  
        onChange={(e)=> handleChange(e.target.value, index)}
        onKeyUp={(e)=> handleBackspaceAndEnter(e, index)}
        onPaste={index === 0 ? handlePaste : null}
        ref={(reference) => (otpBoxReference.current[index] = reference)}
        tabIndex={index + 1}
        className="otp-input"
        />
      ))}
      </div>)}
     </div>


      <p className={`text-lg text-white mt-4 ${otpError ? 'error-show' : ''}`}>{otpError}</p>
      <ResendOtpComponent
      email={email}
      resendClicked={handleResendOtp}
     
      />
        </Paper>
    </div>
  );

  const EmailVerificationScreen = () => (
    <div className="center-container">
      <Paper className="center-paper" style={{width: isTabletOrMobile ? '80%' : '40%'}}>
        <div style={{ padding: '20px' }}>
          <Title text="Enter your email address below" className="boxContent" />
        </div>
        <div className="center">
          <div
            style={{
              textAlign: 'center',
              display: 'flex',
              flexDirection: isTabletOrMobile ? 'column' : 'row',
              alignItems: 'center',
              gap: '10px',
              padding: '20px',
              position: isTabletOrMobile ? '' : 'relative',
            }}
          >
           
            <TextField
              id="outlined-controlled"
              label="Enter Email"
              type="text"
              defaultValue={email}
              onChange={(e)=>handleEmailChange(e)}
              error={emailError}
              //helperText={emailError ? "Enter a valid email address" : ""}
              autoFocus 
            />
            {emailError && <span style={{position: isTabletOrMobile ? '' : 'absolute', color: 'red', fontSize: '12px', bottom: '-5px', paddingLeft:'10px'}}>Enter a valid email address</span>}
            
            <Button 
            variant="contained" 
            onClick={handleVerifyEmailClick}
            startIcon={isLoading && <Spinner size={20} color="white" loading={isLoading} />}
            disabled={emailError}
            >
              Proceed
            </Button>
          </div>
        </div>
      </Paper>
    </div>
  );

  return otpScreen ? <OtpScreen /> : <EmailVerificationScreen />;

    
}

export const OnBoardSportsShops = () =>{
    const [emailVerified, setEmailVerified] = useState(false);
    const [state, setState] = useState({images:[]});
    const [email, setEmail] = useState('');
    const [isLoading, setIsLoading] = useState(false);
    const [showSuccessScreen, setShowSuccessScreen] = useState(false);
    const [stripeLink, setStripeLink] = useState('');
    const [stripeLoaing, setStripeLoading] = useState(false);
    const isTabletOrMobile = useMediaQuery({ query: '(max-width: 900px)' });
    const { register, handleSubmit, formState: { errors } } = useForm();
    const {
        images,
      } = state;
      
    const updateState = (data) => setState((prevState) => ({ ...prevState, ...data }));
    const setEmailAsVerified =(emailValue)=>{
        
        setEmailVerified(true);
        setEmail(emailValue)
    }
    const onImageRemove = (deleteIndex) => {
        const allImages = images;
        allImages.splice(deleteIndex, 1);
        updateState({ images: allImages });
      
      };
      const LoadResizedImage = async (resizedImageBlob, resizedImage) =>{
        return new Promise((resolve) => {
          resizedImage.onload = async () => {
           
      
            const dataURL = await new Promise((innerResolve) => {
              const reader = new FileReader();
              reader.onloadend = () => innerResolve(reader.result);
              reader.readAsDataURL(resizedImageBlob);
            });
      
            resolve(dataURL);
          };
        });
      };
      const onImageChangeUpdate = (imageList) => {
        updateState({ images: imageList });
      };
      const loadImage = async (imageList, img, newImage, imageArray) => {
        return new Promise((resolve) => {
          newImage.onload = async () => {
            let megaPixels = (newImage.width * newImage.height) / 1000000;
      
            if (imageList.length > 0) {
              if (megaPixels > 19) {
                let resizedImage = new Image();
                
                
                let fileToResize = img.file;
                let maxWidth = 3000;
                let maxHeight = 4000;
      
                const imageResizer = ImageResizer(fileToResize, maxWidth, maxHeight);
                try {
                  const resizedImageBlob = await imageResizer.resizeImage();
                  resizedImage.src = URL.createObjectURL(resizedImageBlob);
                  newImage.width = maxHeight;
                  newImage.height = maxHeight;
               
      
                  const resizedImageUrl = await LoadResizedImage(resizedImageBlob, resizedImage);
                  
      
                  imageArray.push({
                    src: resizedImage.src,
                    imageName: img.file.name,
                    imageType: img.file.type,
                    imageb64: resizedImageUrl.split(";")[1].split(",")[1],
                  });
                } catch (error) {
                  console.error('Error resizing image:', error);
                }
              } else {
                imageArray.push({             
                  src: newImage.src,
                  imageName: img.file.name,
                  imageType: img.file.type,
                  imageb64: img.data_url.split(";")[1].split(",")[1],
                  image : img
                });
              }
            }
      
            resolve(imageArray);
          };
        });
      };
    const onImageChange = async (imageList, addUpdateIndex) => {
        
        let images = [];
        for (let index = 0; index < imageList.length; index++){
          const img = imageList[index];
          if (!img.image) {
            let newImage = new Image();
            newImage.src = URL.createObjectURL(img.file);
            images = await loadImage(imageList, img, newImage, images);
          } else {
            images.push(img);
          }
        };
        updateState({ images: images });
       
      };
      const onSubmit = async (e) => {
       
        setIsLoading(true);
        const data={
          Name:e.Name,
          Email:email,
          City:e.City,
          CountryCode:e.CountryCode,
          Street:e.Street,
          Password:e.Password,
          PostalCode:e.PostalCode,
          StateOrProvinceCode:e.StateOrProvinceCode,
          Phone:e.Phone,
          Images:images,         
          BrandEmail:e.BrandEmail,
          BrandName:e.BrandName,
          CatelogUrl:e.Catalogue,
          YearOfBusiness:e.Year,
          OperatingAddress:e.OperatingAddress,
        }

        try {
            const response = await axios({
                url: REGISTERSPORTSSHOP, 
                method: "POST",
                responseType: "json",
                data: data
            });
        
            if(response.status === 200) {
                //setCountdown(60);
              if(response.data?.data?.isSuccessFul)
                {
                    toast.success("Account Created Succesfully");
                    setShowSuccessScreen(true);
                    setStripeLink(response.data.data.stripeLink);
                }else{
                    toast.error(response.data?.data?.message ?? "Error occured creating account");
                    
                }
                
                }else{
                    toast.error("Account Creation Failed")
                }

            
        } catch (e) {
           
            console.error(e);
            setIsLoading(false);
            toast.error("Error occured creating account");
        }
        setIsLoading(false);
    }
    const handleStripeClick = () => {
        setStripeLoading(true);
        window.location.href = stripeLink;
      };
    function SuccessScreen({ open }) {
        return (
          <Paper className="padding" style={{width:!isTabletOrMobile &&'800px',margin:'auto'}}>
            <Stack spacing={2}>
             
              <Title className="boxContent" style={{textAlign:'left'}} text={"Final Step: Click the button below to link your stripe to The Cricket Store. This will set up and link your account to The Cricket Store seamlessly"}/>
              <Button startIcon={stripeLoaing && <Spinner size={20} color="white" loading={stripeLoaing} />} style={{padding:'15px', width:'60%', height:'10px', textAlign:'center', alignSelf:'center'}}variant="contained" color="primary" onClick={handleStripeClick}>
                        Link Stripe
                      </Button>
               
              
              
            </Stack>
          </Paper>
        );
      }

    return (
       
        <div>
             <Toaster />
            <div className="headerTxtBtmLeft" style={{padding:'20px', textAlign:'center'}}>
                {showSuccessScreen ? (<span>Welcome! We are delighted to have you join us.</span>) : (<span>The Cricket Store Sports Shop Merchant Onboarding</span>)}
            </div>
            {!emailVerified ? (<VerifyEmailScreen
        updateEmailVerification={setEmailAsVerified}
        />) : 
        (<div className="dispatchTimer" style={{  position: 'relative', padding:'20px', alignSelf:'center' }}>
        <div style={{ width: '100%', background: 'white', marginTop: '10px', alignSelf:'center' }}>
            {showSuccessScreen ?( <SuccessScreen />) :(
                <Paper className="" style={{width:!isTabletOrMobile &&'800px',margin:'auto', paddingBottom:'20px', alignSelf:'center', padding:'20px'}}>
                <Title text={"Kindly fill this form"} className="boxContentCenter"/>
                <form onSubmit={handleSubmit(onSubmit)}>
                <Grid container columnSpacing={3} rowSpacing={3}>
                    <Grid item md={6} mdOffset={6}>
                                    <label >Brand Logo</label>
                                    <Stack direction={'row'} spacing={0} className="center box">
                                     {images.length === 0 && <ImageUploading
                                        data-testid="file-uploader"
                                        value={images}
                                        onChange={onImageChange}
                                        dataURLKey="data_url"
                                        maxFileSize={157286400}
                                        acceptType={["png", "jpg", "jpeg"]}
                                        multiple
                                        maxNumber={1}
                                        
                                      >
                                        {({
                                          imageList,
                                          onImageUpload,
                                          dragProps,
                                          isDragging,
                                          errors,
                                        }) => (
                                          <>
                                            <div style={{height:'100px'}} className="imageGrid center2" {...dragProps}>
                                              {isDragging && ""}
                                              <SecondaryButton
                                                text={"Upload Brand Logo"}
                                                className="addFormCls"
                                                onClick={onImageUpload}
                                                disabled={images.length === 1 ? true : false}
                                              />
                                            </div>
                                            {errors && (
                                              <div>
                                                {errors.maxFileSize && (
                                                  <span className="errorTexCls">
                                                    Selected image size exceed 10MB
                                                  </span>
                                                )}
                                                {errors.resolution && (
                                                  <span className="errorTexCls">
                                                    Selected image resolution exceed 20MP
                                                  </span>
                                                )}
                                                {errors.maxNumber && (
                                                  <span className="errorTexCls">
                                                    Number of selected images exceed max (10) allowed
                                                    images.
                                                  </span>
                                                )}
                                                {errors.acceptType && (
                                                  <span className="errorTexCls">
                                                    Selected file type is not allowed.
                                                  </span>
                                                )}
                                              </div>
                                            )}
                                          </>
                                        )}
                                      </ImageUploading>}
        
                                      <DndProvider backend={HTML5Backend}>
                                        <Container
                                          dragData={state.images}
                                          onImageRemove={onImageRemove}
                                          onImageChangeUpdate={onImageChangeUpdate}
                                        />
                                      </DndProvider>
                                    </Stack>
                                   
        
                                   
                                  </Grid>
                                  <Grid item md={6} xs={6}>
                                    
                                  </Grid>
                  <Grid item md={6} xs={6}>
                                  <label >Business Name</label>
                                  <TextField fullWidth size="small" type="text"  {...register("Name",{ required: true})}
                                    placeholder="Full Business Name" />
                                    {errors.firstName &&  <p className="error">full business name is required</p>}
                                </Grid>
                                <Grid item md={6} xs={6}>
                                  <label >Brand Name</label>
                                  <TextField fullWidth size="small" type="text"  {...register("BrandName",{ required: true})}
                                    placeholder="Brand Name" />
                                    {errors.BrandName &&  <p className="error">BrandName is required</p>}
                                </Grid>
        
                                <Grid item md={6} xs={6}>
                                  <label className='space-top'>Phone</label>
                                  <TextField fullWidth size="small" type="phone"  {...register("Phone",{ required: true})}
                                    placeholder="Enter Phone" />
                                    {errors.Phone &&  <p className="error">Phone is required</p>}
                                </Grid>
        
                                <Grid item md={6} xs={6}>
                                  <label>Account Email</label>
                                  <TextField fullWidth size="small" type="email"   {...register("Email")}
                                    placeholder="Email Address" 
                                    defaultValue={email}
                                    value={email}
                                    InputProps={{
                                        readOnly: true,
                                      }}
                                    />
                                 
                                </Grid>
        
                                <Grid item md={6} xs={6}>
                                  <label>Other Emails</label>
                                  <TextField fullWidth size="small" type="text"   {...register("BrandEmail")}
                                    placeholder="Other Notification Email (Optional)" />
                                </Grid>
        
                                
                                
                                <Grid item md={6} xs={6}>
                                  <label className='space-top'>Street</label>
                                  <TextField fullWidth size="small" type="text"  {...register("Street",{ required: true})}
                                    placeholder="Street name" />
                                    {errors.Street &&  <p className="error">Street is required</p>}
                                </Grid>
        
                                <Grid item md={6} xs={6}>
                                  <label className='space-top'>City</label>
                                  <TextField fullWidth size="small" type="text"  {...register("City",{ required: true})}
                                    placeholder="City" />
                                    {errors.City &&  <p className="error">City is required</p>}
                                </Grid>
        
                                <Grid item md={6} xs={6}>
                                  <label className='space-top'>Country Code</label>
                                  <TextField fullWidth size="small" type="text"  {...register("CountryCode",{ required: true})}
                                    placeholder="Country Code" />
                                    {errors.CountryCode &&  <p className="error">Country Code is required</p>}
                                </Grid>
        
                                <Grid item md={6} xs={6}>
                                  <label className='space-top'>Postal Code</label>
                                  <TextField fullWidth size="small" type="text"  {...register("PostalCode",{ required: true})}
                                    placeholder="Postal Code" />
                                    {errors.PostalCode &&  <p className="error">Postal Code is required</p>}
                                </Grid>
        
                                <Grid item md={6} xs={6}>
                                  <label className='space-top'>{isTabletOrMobile?"State Code":"State Or Province Code"}</label>
                                  <TextField fullWidth size="small" type="text"  {...register("StateOrProvinceCode",{ required: true})}
                                    placeholder="State Or Province Code" />
                                    {errors.StateOrProvinceCode &&  <p className="error">State Or Province Code is required</p>}
                                </Grid>
                               
        
                                <Grid item md={6} xs={6}>
                                  <label className='space-top'>Catalogue URL</label>
                                  <TextField fullWidth size="small" type="text"  {...register("Catalogue")}
                                    placeholder="Catalogue URL (Optional)" />
                                </Grid>
        
                                <Grid item md={6} xs={6}>
                                  <label className='space-top'>Year of Business</label>
                                  <TextField fullWidth size="small" type="text"  {...register("Year")}
                                    placeholder="Year of Business (Optional)" />
                                </Grid>
                    </Grid>
                    <div style={{padding:'20px', textAlign:'right'}}>
                    <Grid item xs={12}>
                      <Button startIcon={isLoading && <Spinner size={20} color="white" loading={isLoading} />}variant="contained" color="primary" type="submit">
                        Submit
                      </Button>
                    </Grid>
                    </div>
                 
                </form>
                    </Paper>
            )}
            
        </div>
        
        </div>)
        }
        

        </div>
    );
};

export default OnBoardSportsShops;